import { FC } from "react";
import { Alert } from "react-bootstrap";
import FlexBox from "./flex-box";

interface ErrorBoxProps extends React.HTMLAttributes<HTMLDivElement> {
  message: string;
  children?: React.ReactNode;
}

const ErrorBox: FC<ErrorBoxProps> = ({ message, children, ...props }) => {
  if (!message) {
    return <>&nbsp;</>;
  }

  return (
    <>
      <Alert variant={"danger"} {...props}>
        <strong className="font-bold">Error!&nbsp;</strong>
        <span className="block sm:inline">{message}</span>
      </Alert>
      {children && <FlexBox className="mt-2">{children}</FlexBox>}
    </>
  );
};

export default ErrorBox;
